/*
  Perguntas frequentes .

  Regra medida na referencia em 2026-08-26: o acordeao e EXCLUSIVO - abrir uma pergunta
  fecha a que estava aberta, inclusive quando as duas ficam em colunas diferentes. O
  clique na pergunta ja aberta fecha ela.

  A animacao mora no CSS (grid-template-rows). Aqui so alternamos a classe e o estado
  de acessibilidade, e e por isso que o arquivo e curto de proposito.
*/
(function () {
  if (window.__mdFaqInit) return;
  window.__mdFaqInit = true;

  function fechar(item) {
    if (!item || !item.classList.contains('esta-aberto')) return;
    item.classList.remove('esta-aberto');
    var b = item.querySelector('.ui-faq__pergunta');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  function alternar(botao) {
    var item = botao.closest('.ui-faq__item');
    var faixa = botao.closest('.ui-faq');
    if (!item || !faixa) return;

    var jaAberto = item.classList.contains('esta-aberto');

    // exclusivo: a faixa inteira, e nao so a coluna - e assim que a referencia se comporta
    var abertos = faixa.querySelectorAll('.ui-faq__item.esta-aberto');
    for (var i = 0; i < abertos.length; i++) fechar(abertos[i]);

    if (!jaAberto) {
      item.classList.add('esta-aberto');
      botao.setAttribute('aria-expanded', 'true');
    }
  }

  /*
    "Ver mais" (The Derby 2026-10-22): revela as perguntas extras com animacao. A caixa
    cresce da altura antiga pra nova (a caixa tem overflow hidden, entao o que chega fica
    cortado ate a hora certa) e as perguntas novas entram em cascata, subindo um pouco.
    Acionado pelo teclado (click com detail 0), o foco vai pra primeira pergunta revelada;
    no toque/mouse nao, senao o contorno de foco aparece sem motivo.
  */
  function expandir(botao, pelTeclado) {
    var faixa = botao.closest('.ui-faq');
    if (!faixa) return;
    if (faixa.classList.contains('ui-faq--expandida')) return recolher(faixa, botao);
    var caixa = faixa.querySelector('.ui-faq__caixa');
    var itens = faixa.querySelectorAll('.ui-faq__item');
    var ocultos = [];
    for (var i = 0; i < itens.length; i++) {
      if (getComputedStyle(itens[i]).display === 'none') ocultos.push(itens[i]);
    }
    var antes = caixa.offsetHeight;
    faixa.classList.add('ui-faq--expandida');
    botao.setAttribute('aria-expanded', 'true');
    var depois = caixa.offsetHeight;

    if (pelTeclado && ocultos[0]) {
      var primeira = ocultos[0].querySelector('.ui-faq__pergunta');
      if (primeira) primeira.focus({ preventScroll: true });
    }

    var reduzir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduzir || !caixa.animate) return;
    caixa.animate([{ height: antes + 'px' }, { height: depois + 'px' }], {
      duration: 550,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    });
    for (var k = 0; k < ocultos.length; k++) {
      ocultos[k].animate(
        [
          { opacity: 0, transform: 'translateY(12px)' },
          { opacity: 1, transform: 'none' },
        ],
        { duration: 420, delay: 90 + k * 70, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)', fill: 'backwards' }
      );
    }
  }

  /*
    "Ver menos": as perguntas extras somem num fade rapido, depois a caixa encolhe da
    altura aberta pra fechada. A pagina e compensada pra o botao ficar parado sob o dedo,
    senao quem estava la embaixo e jogado pra outra secao quando a caixa encolhe.
  */
  function recolher(faixa, botao) {
    var caixa = faixa.querySelector('.ui-faq__caixa');
    var itens = faixa.querySelectorAll('.ui-faq__item');
    var reduzir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // quais perguntas vao sumir: tira a classe so pra medir e devolve no mesmo quadro
    faixa.classList.remove('ui-faq--expandida');
    var saindo = [];
    for (var i = 0; i < itens.length; i++) {
      if (getComputedStyle(itens[i]).display === 'none') saindo.push(itens[i]);
    }
    faixa.classList.add('ui-faq--expandida');

    function encolher() {
      // resposta aberta numa pergunta que vai sumir fecha junto
      for (var a = 0; a < saindo.length; a++) fechar(saindo[a]);
      var antes = caixa.offsetHeight;
      var topoBotao = botao.getBoundingClientRect().top;
      faixa.classList.remove('ui-faq--expandida');
      botao.setAttribute('aria-expanded', 'false');
      window.scrollBy(0, botao.getBoundingClientRect().top - topoBotao);
      var depois = caixa.offsetHeight;
      if (!reduzir && caixa.animate) {
        caixa.animate([{ height: antes + 'px' }, { height: depois + 'px' }], {
          duration: 450,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        });
      }
    }

    if (reduzir || !saindo.length || !saindo[0].animate) return encolher();
    var ultima = null;
    for (var k = 0; k < saindo.length; k++) {
      ultima = saindo[k].animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-in', fill: 'forwards' });
    }
    ultima.onfinish = function () {
      encolher();
      for (var m = 0; m < saindo.length; m++) {
        var anims = saindo[m].getAnimations ? saindo[m].getAnimations() : [];
        for (var n = 0; n < anims.length; n++) anims[n].cancel();
      }
    };
  }

  // delegacao no documento: cobre as secoes que o editor de tema injeta depois da carga
  document.addEventListener('click', function (evento) {
    if (!evento.target.closest) return;
    var botao = evento.target.closest('.ui-faq__pergunta');
    if (botao) return alternar(botao);
    var mais = evento.target.closest('.ui-faq__mais');
    if (mais) expandir(mais, evento.detail === 0);
  });

  /*
    No editor, selecionar um bloco no painel da esquerda deve abrir a pergunta
    correspondente - senao o cliente clica na resposta pra editar e nao ve nada acontecer.
  */
  document.addEventListener('shopify:block:select', function (evento) {
    var item = evento.target.closest ? evento.target.closest('.ui-faq__item') : null;
    if (!item) return;
    // bloco escondido atras do "ver mais": abre a lista antes, senao o editor nao mostra nada
    if (getComputedStyle(item).display === 'none') {
      var mais = item.closest('.ui-faq') && item.closest('.ui-faq').querySelector('.ui-faq__mais');
      if (mais) expandir(mais);
    }
    var botao = item.querySelector('.ui-faq__pergunta');
    if (botao && !item.classList.contains('esta-aberto')) alternar(botao);
  });
})();
